export default {
  modelsZgi: null,
  modelsCut: null,
  modelsOpt: null,
  materialsZgi: [],
  materialsCut: [],
  materialsOpt: [],
  configCut: null,
  orderEdit: null,
  setList: [],
  payment: null,
  optionsList: [],
  orderCopy: {
    path: null,
    data: null,
  },
  prices: 0,
  zgiTender: false,
  cutTender: false,
  order: [],
  isDisabledAddToCart: false,
};
